import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {when} from 'lit/directives/when.js';
import store from '../../store';


@customElement('solar-specsheet')
export class SolarSpecsheet extends connect(store)(LitElement) {

	static styles = [
		//cssProperties,
		css`
		:host {
			font-family: var(--font-family-light);
		}
		`
	];
	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
	}

	render() {
		return html`
			<solar-specsheet-page>
				<page-solar-summary></page-solar-summary>
			</solar-specsheet-page>
			<solar-specsheet-page>
				<solar-technical-data></solar-technical-data>
			</solar-specsheet-page>
			<solar-specsheet-page>
				<solar-light-engine></solar-light-engine>
			</solar-specsheet-page>
			<solar-specsheet-page>
				<solar-page-tender-text></solar-page-tender-text>
			</solar-specsheet-page>

		`;
		}
	}
